import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject, Subscription, filter, map } from 'rxjs';
import { GenericEdit } from 'src/app/interfaces/generic-edit';
import { HTTPService } from 'src/app/services/http.service';
import { ObjectUtil } from '../utils/ObjectUtil';
import { JsonFormsPopupComponent } from '../json-forms-popup/json-forms-popup.component';
import { DialogService } from 'src/app/services/dialog.service';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'log-integracao-item',
    templateUrl: './log-integracao-item.component.html',
    styleUrl: './log-integracao-item.component.scss',
    standalone: false
})
export class LogIntegracaoItemComponent {

  controle:{key:string,value:any}[] = [];
  @Input() data:GenericEdit;
  public listSync:BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);
  public listSyncFiltered:BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);
  @Output() saving:EventEmitter<{changing:boolean, keepOpen:boolean}> = new EventEmitter();
  sub1:Subscription;
  sub2:Subscription;
  filterCompany:FormControl<string> = new FormControl();
  companyList:{key:string,name:string}[] = [];

  constructor(private http:HTTPService, private dialog:DialogService){

  }

  expandAll(open:boolean){
    this.listSyncFiltered.getValue().forEach((item:any)=>{
      item.panelActive = open;
      open ? this.openDetail(item) : this.closeDetail(item);
    });
  }

  onPanelChange(item, active:boolean){
    item.panelActive = active;
    active ? this.openDetail(item) : this.closeDetail(item);
  }

  getBadge(control:FormControl){
    if ( ObjectUtil.isNotEmpty(control.value)){
      if ( control.value instanceof Array ){
        return control.value.length;
      }else{
          return 1;
      }
    }
    return null;
    
}

  ngOnInit(){
      this.filterCompany.valueChanges.subscribe((data:any)=>this.filterData(data));
      this.loadItens();
  }


  loadItens() {
      let ob = {
          entityName:'Mktplgi',
          //type:"mongo",
          sql:`SELECT 
              A.IDJOB,
              A.IDCONF,
              A.SEQUENCE, 
              B.NAME, 
              A.SERVERNAME, 
              A.CODECOMPANY,
              C.NAME CODECOMPANY_NAME,
              A.RECMODIFYON,
              A.HEADER,
              FROM MKTPLGI A 
                LEFT OUTER JOIN MKTPCFI B (NOLOCK) ON B.IDCONF=A.IDCONF AND B.SEQUENCE=A.SEQUENCE
                INNER JOIN MKTPCOMPANIES C (NOLOCK) ON C.CODECOMPANY=A.CODECOMPANY
              WHERE A.IDJOB='${this.data.row['IDJOB']}'
              ORDER BY A.SEQUENCE DESC`
      }

      //WHERE IDCONF=${this.data.row['IDCONF']}`
      this.sub1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,false).subscribe(data=>{
          this.listSync.next(data['SQL']);
          this.listSyncFiltered.next(data['SQL']);
          this.loadFilter(data['SQL']);
      });
  }
  loadFilter(sql: Object[]) {
    let setCompanySet = new Set();

    new Set(sql.map(v=>(JSON.stringify({codecompany:v['CODECOMPANY'], name:v['CODECOMPANY_NAME']})))).forEach(d=>{
      setCompanySet.add(d);
    });
  
    this.companyList = Array.from(setCompanySet).map((d:string)=>({key:JSON.parse(d).codecompany,name:JSON.parse(d).name})).sort((data,data2)=>{
      if ( data.name > data2.name  ) return 1;
      if ( data.name < data2.name  ) return -1;
      return 0;
    });
  }

  ngOnDestroy(){
      if ( this.sub1 != null){ this.sub1.unsubscribe();}
      if ( this.sub2 != null){ this.sub2.unsubscribe();}
  }

  openDetail(item){
      item.open = true;
      this.getDetail(item);
  }

  closeDetail(item){
      item.open = false;
  }

  getDetail(item){
    let ob = {
      entityName:'Mktplgioff',
      sql:`SELECT 
          A.IDOFF,
          A.REQUEST,
          A.RESPONSE,
          A.URL,
          '${item.HEADER}' AS HEADER,
          RECMODIFIEDON
          FROM MKTPLGIOFF A (NOLOCK)
          WHERE A.IDJOB='${item.IDJOB}'
          AND A.SEQUENCE=${item.SEQUENCE}
          ORDER BY A.IDOFF DESC`
      }

    //WHERE IDCONF=${this.data.row['IDCONF']}`
    this.sub2 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,false).subscribe(data=>{
        item.listSyncDetail = new BehaviorSubject(data['SQL']);
    });

  }

  openJSONPopUp(value,descricao){

    if ( ObjectUtil.isNotEmpty(value)  ){  
      try{
        
        if( (value as string).startsWith('{') || (value as string).startsWith('[')){
          let ob = JSON.parse(value); 
        
          let data = {
                        json: value,
                        json_original: value,
                        main: descricao
          }
          this.dialog.openGenericDialog(JsonFormsPopupComponent,data,(values)=>{
            //this.saveData(values);
          },()=>{
          },'100%');
        }
      }catch( Exception){
      }
    }
  }

  filterData(data:Object[]){
      if ( data.length == 0){
        this.listSync.subscribe(val=>this.listSyncFiltered.next(val));
      }else{
        this.listSync.subscribe(val=>{
          let newObject = val.filter(tf=>data.some(d=>tf['CODECOMPANY']==d));
          this.listSyncFiltered.next(newObject);
        });
      }
  }

  

}
